import React from 'react';
import { Box } from '@mui/material';
import type { GalleryPhoto } from '../GalleryGrid';
import PhotoCard from '../PhotoCard';

export interface UniformRowProps {
   photos: GalleryPhoto[];
   startIndex: number;
   onPhotoClick: (index: number) => void;
   currentUser?: { uid: string } | null;
   albumId?: string;
   onUploaderClick?: (photo: GalleryPhoto) => void;
}

export default function UniformRow({
   photos,
   startIndex,
   onPhotoClick,
   currentUser,
   albumId,
   onUploaderClick,
}: UniformRowProps) {
   return (
      <Box
         sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${Math.max(1, Math.min(5, photos.length))}, 1fr)`,
            gap: 2,
            mb: 4,
            '@media (max-width: 640px)': {
               gridTemplateColumns: 'repeat(2, 1fr)',
            },
            '@media (min-width: 641px) and (max-width: 1024px)': {
               gridTemplateColumns: 'repeat(4, 1fr)',
            },
            '@media (min-width: 1025px)': {
               gridTemplateColumns: 'repeat(5, 1fr)',
            },
         }}
      >
         {photos.map((photo, i) => (
            <Box key={photo.id} sx={{ aspectRatio: '1 / 1', minHeight: 80 }}>
               <PhotoCard
                  photo={photo}
                  aspectRatio='square'
                  onClick={() => onPhotoClick(startIndex + i)}
                  showLikeButton={!!currentUser}
                  userId={currentUser?.uid}
                  albumId={albumId}
                  likeCount={photo.likeCount ?? 0}
                  isLiked={photo.isLiked ?? false}
                  onUploaderClick={onUploaderClick}
               />
            </Box>
         ))}
      </Box>
   );
}
